import { render } from "./StatPanierMoyenUser.vue?vue&type=template&id=2aeed380&scoped=true"
import script from "./StatPanierMoyenUser.vue?vue&type=script&lang=js"
export * from "./StatPanierMoyenUser.vue?vue&type=script&lang=js"

import "./StatPanierMoyenUser.vue?vue&type=style&index=0&id=2aeed380&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aeed380"]])

export default __exports__